export default class RadioSelected extends HTMLElement {
  static define(tagName = 'radio-selected') {
    try {
      window.customElements.define(tagName, this);
    } catch (e) {
      /* console.error(e); */
    }
  }
  connectedCallback() {
    this.innerHTML = `<svg pointer-events="none" viewBox="0 0 17 17">
  <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
    <circle cx="7.5" cy="7.5" r="7.5" fill="#FFFFFF" stroke="#5A5958" stroke-width=".5"/>
    <circle cx="7.498" cy="7.489" r="5" fill="currentColor"/>
  </g>
</svg>
`;
  }
}
RadioSelected.define();


// WEBPACK FOOTER //
// ./assets/icons/radio-selected.svg